var radioButtons = document.querySelectorAll('input[name="collection"]')    
radioButtons.forEach((radioButton) => {
    radioButton.addEventListener( 'change', function(event) {
        if( this.checked ){
            document.querySelector('.product-grid-container').classList.add('loading');
            document.querySelector('#sidebar-collection-title li.checked')?.classList.remove('checked');
            document.querySelectorAll('.active').forEach( (active) =>  active.classList.remove('active'))
            document.querySelectorAll('.closed').forEach( (closed) =>  closed.classList.remove('closed'))

            event.target.parentElement.classList.add('checked');
            event.target.parentElement.classList.add('active');
            let nextSibling = event.target.parentElement.nextElementSibling;

            while(nextSibling) {
                if (nextSibling.classList.contains('child-item')) {
                    nextSibling.classList.add('active');
                    nextSibling = nextSibling.nextElementSibling;
                } else {
                    nextSibling = null;
                    break;
                }
            }

            let prevSibling = event.target.parentElement.previousElementSibling;

                while(prevSibling) {
                    if (!( prevSibling.classList.contains('child-item') && event.target.parentElement.classList.contains('parent-item') )) {
                        if (prevSibling.classList.contains('child-item')) {
                            prevSibling.classList.add('active');
                            prevSibling = prevSibling.previousElementSibling;
                        } else {
                            prevSibling = null;
                            break;
                        }
                    } else {
                        prevSibling = null;
                        break;
                    }
                }


            var getPreviousSibling = function (elem, selector) {

                // Get the next sibling element
                var sibling = elem.previousElementSibling;
            
                // If there's no selector, return the first sibling
                if (!selector) return sibling;
            
                // If the sibling matches our selector, use it
                // If not, jump to the next sibling and continue the loop
                while (sibling) {
                    if (sibling.matches(selector)) return sibling;
                    sibling = sibling.previousElementSibling;
                }
            
            };

            const checked = document.querySelector('#sidebar-collection-title li.checked');

            if (checked.classList.contains('child-item')) {
                var prevParent = getPreviousSibling(checked, '.parent-item');
                prevParent.classList.add('active');
            }

            fetch( this.value )
                .then((response) => response.text())
                .then((responseText) => {
                const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
                productElement = responseHTML.querySelector('.product-grid-container .collection');
                collectionTitle = responseHTML.querySelector('.product-grid-container .collection-hero__title');
                collectionDescription = responseHTML.querySelector('.product-grid-container .collection-hero__description') || '';
                console.log({collectionDescription});
                //window.location.replace(this.value);
                history.pushState(null, collectionTitle, this.value);
                document.querySelector('.product-grid-container .collection').innerHTML = productElement.innerHTML;
                document.querySelector('.product-grid-container .collection-hero__title').innerHTML = collectionTitle.innerHTML;
                var targetDescription = document.querySelector('.product-grid-container .collection-hero__description');
                console.log({targetDescription});
                if (typeof collectionDescription == 'undefined' || collectionDescription == null || collectionDescription == '' ) {
                   if( typeof targetDescription != 'undefined' || targetDescription != null ) {
                     targetDescription.innerHTML = '';
                   }
                } else {
                    console.log('first')
                   if( targetDescription != 'undefined' || targetDescription != null ) {
                    console.log(collectionDescription.innerHTML);
                    if (typeof collectionDescription.innerHTML != 'undefined' || targetDescription != null ) {
                        targetDescription.innerHTML = collectionDescription.innerHTML;
                    }
                     
                   }
                }
                document.querySelector('.product-grid-container').classList.remove('loading');
            });
        }
    });
});

var checkedParent = document.querySelectorAll('#sidebar-collection-title li.parent-item');
checkedParent.forEach( (parent) => { 
    let nextParentSibling = parent.nextElementSibling;
    if(nextParentSibling.classList.contains('parent-item')) {
        parent.classList.add('has-no-child');
    }

    parent.addEventListener('click', function(event) {
        let closestParent;
        if (this == event.target) {
            closestParent = this;
        } else {
            if (event.target.classList.contains('title-item')) {
                closestParent = event.target.closest('.parent-item');
            }
        }

        if (closestParent.classList.contains('closed')) {
            closestParent.classList.remove('closed');
            closestParent.classList.add('active');
        
            let nextSibling = closestParent.nextElementSibling;
        
            while(nextSibling) {
                if (nextSibling.classList.contains('child-item')) {
                    nextSibling.classList.add('active');
                    nextSibling = nextSibling.nextElementSibling;
                } else {
                    nextSibling = null;
                    break;
                }
            }
        } else {
            if (closestParent.classList.contains('checked')) {
                document.querySelectorAll('.active').forEach( (active) =>  active.classList.remove('active'));
                closestParent.classList.add('closed');
            } else {
                console.log("Trigger change");
                console.log(closestParent.querySelector('input[name="collection"]'));
                closestParent.querySelector('input[name="collection"]').checked = true;
                closestParent.querySelector('input[name="collection"]').dispatchEvent( new Event('change') );
            }
        }

    }, false)
});

var rcradioButtons = document.querySelectorAll('.recharge-radio');
var selling_plans = document.querySelectorAll('[name="selling_plan"]');

function rcradioButtonChange() {
    if( this.checked ){
        if( this.value == 'onetime' ){
            selling_plans.forEach((selling_plan) => {
                selling_plan.disabled = true;
            });
            document.querySelector('#sub-type').style.display = 'none';
            document.querySelector('.subscribe-btn').style.display = 'none';
            document.querySelector('.one-time-btn').style.display = 'flex';
            document.querySelector('.product-form__buttons-price .subcription-price').style.display = 'none';
            document.querySelector('.product-form__buttons-price .regular-price').style.display = 'block';
        }
        else{
            selling_plans.forEach((selling_plan) => {
                selling_plan.disabled = false;
            });
            document.querySelector('#sub-type').style.display = 'block';
            document.querySelector('.subscribe-btn').style.display = 'flex';
            document.querySelector('.one-time-btn').style.display = 'none';
            document.querySelector('.product-form__buttons-price .subcription-price').style.display = 'block';
            document.querySelector('.product-form__buttons-price .regular-price').style.display = 'none';
        }
    }
}

rcradioButtons.forEach((radioButton) => {
    radioButton.addEventListener( 'change', rcradioButtonChange);
});

if( document.querySelector('.recharge-radio:checked') != null ) {
    document.querySelector('.recharge-radio:checked').dispatchEvent( new Event('change') );
}

function scrollIntoViewIfNeeded(target) { 

    var headerOffset = 300;

    var offsetPosition = target.getBoundingClientRect().top + window.pageYOffset - headerOffset;

    window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
   });
}


var accordionInputs = document.querySelectorAll('.accordion input,.faq__each--accordion input');
accordionInputs.forEach((accordionInput) => {
    accordionInput.addEventListener( 'click', function(e) {
        if( this.getAttribute("data-open") == "true" ){
            this.checked = false;
            accordionInputs.forEach((accordionInput) => {
                accordionInput.setAttribute("data-open", "false");
            });
        }
        else {
            accordionInputs.forEach((accordionInput) => {
                if( accordionInput == this ){
                    accordionInput.setAttribute("data-open", "true");
                }
                else {
                    accordionInput.setAttribute("data-open", "false");
                }
            });
            this.setAttribute("data-open", "true");
            var content = this.nextElementSibling.nextElementSibling;
            content.style.height = content.scrollHeight + 'px';
            var _this = this;
            setTimeout(function(){
                scrollIntoViewIfNeeded(_this)
            }, 1000);
        }
    });

    if ( accordionInput.id == "nutrition_instructions--accordion") {
        accordionInput.checked = true;
        accordionInput.setAttribute("checked", checked);
        accordionInput.setAttribute("data-open", "true");
        var content = accordionInput.nextElementSibling.nextElementSibling;
        content.style.height = content.scrollHeight + 'px';
    }
    if( accordionInput.checked){
        accordionInput.setAttribute("data-open", "true");
        var content = accordionInput.nextElementSibling.nextElementSibling;
        content.style.height = content.scrollHeight + 'px';
    }
});

function delegate(el, evt, sel, handler) {
    el.addEventListener(evt, function(event) {
        var t = event.target;
        while (t && t !== this) {
            if (t.matches(sel)) {
                handler.call(t, event);
            }
            t = t.parentNode;
        }
    });
}

delegate(document, "click", '[href="#recover"]', function(event) {
    document.querySelector('.accounts-sidebar-heading').classList.add('reset-selected');
});

delegate(document, "click", '[href="#create"]', function(event) {
    document.querySelector('.accounts-sidebar-heading').classList.add('create-selected');
});

delegate(document, "click", '[href="#cancel"]', function(event) {
    document.querySelector('.accounts-sidebar-heading').classList.remove('create-selected','reset-selected');
});


document.addEventListener('click', function (event) {

	// If the clicked element doesn't have the right selector, bail
	if (!event.target.matches('body#subscription .rich-text-with-image__blocks .button')) return;

	// Don't follow the link
	event.preventDefault();

    var anchor = document.querySelector('#Subscription-Options-Top');
    anchor.scrollIntoView({block: "start", behavior: "smooth"});

}, false);


// Sticky add to cart

var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function (entry) {
        if(entry.isIntersecting === false){
            //console.log('Element is hidden');
            let scrollHeight = window.scrollY;
            let buttonHeight = entry.target.offsetTop ;
            if(scrollHeight > buttonHeight) {
                //setTimeout(function(){ 
                    document.querySelector('.sticky-addtocart').classList.add('sticky');
                //}, 1000)
            }
        } else {
            //console.log('Element is visible');
            //clearTimeout();
            document.querySelector('.sticky-addtocart').classList.remove('sticky');
        }
    });
});

//observer.observe(document.querySelector('.product-form .qty-add-cnt .product-form__submit'));
let passScroll = document.querySelector('#stickyMark');

observer.observe(passScroll);



document.querySelector('.sticky-addtocart .product-form__input select').addEventListener('change', function(){
    
    var stickyVariantValue = this.value;
    document.querySelector(':not(.sticky-addtocart) variant-radios input[value*="'+ stickyVariantValue +'"]').click();
});


var radioButtons = document.querySelectorAll(':not(.sticky-addtocart) variant-radios input[type="radio"]')    
radioButtons.forEach((radioButton) => {
    radioButton.addEventListener( 'change', function(event) {
        var variantValue = this.value;
        document.querySelector('.sticky-addtocart .product-form__input select').value = variantValue;
    })
});
